import React, {}  from 'react'
import{
    YgIcon, fontSize, color, color1Y, color2Y, color3Y, color4Y, color4YDeep, color5Y,
}from '../components/yg-icon'
import {DELIVERY_TYPE_MIX,} from "../utills/constants";
//list页面form布局
export const listFormItemLayout = {
    labelCol: {
        lg: {span: 7},
        md: {span: 9},
    },
    wrapperCol: {
        lg: {span: 14},
        md: {span: 12},
    },
};
export const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        md: {
            span: 24,
            offset: 0,
        },
    },
}
/**
 * 深比较
 * @param x
 * @param y
 * @returns {boolean}
 */
export function deepCompare(x, y) {
    var i, l, leftChain, rightChain;

    function compare2Objects(x, y) {
        var p;
        // remember that NaN === NaN returns false
        // and isNaN(undefined) returns true
        if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
            return true;
        }
        // Compare primitives and functions.
        // Check if both arguments link to the same object.
        // Especially useful on the step where we compare prototypes
        if (x === y) {
            return true;
        }
        // Works in case when functions are created in constructor.
        // Comparing dates is a common scenario. Another built-ins?
        // We can even handle functions passed across iframes
        if ((typeof x === 'function' && typeof y === 'function') ||
            (x instanceof Date && y instanceof Date) ||
            (x instanceof RegExp && y instanceof RegExp) ||
            (x instanceof String && y instanceof String) ||
            (x instanceof Number && y instanceof Number)) {
            return x.toString() === y.toString();
        }
        // At last checking prototypes as good as we can
        if (!(x instanceof Object && y instanceof Object)) {
            return false;
        }
        if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
        }
        if (x.constructor !== y.constructor) {
            return false;
        }
        if (x.prototype !== y.prototype) {
            return false;
        }
        // Check for infinitive linking loops
        if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
            return false;
        }
        // Quick checking of one object being a subset of another.
        // todo: cache the structure of arguments[0] for performance
        for (p in y) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
        }
        for (p in x) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
            switch (typeof(x[p])) {
                case 'object':
                case 'function':
                    leftChain.push(x);
                    rightChain.push(y);
                    if (!compare2Objects(x[p], y[p])) {
                        return false;
                    }
                    leftChain.pop();
                    rightChain.pop();
                    break;
                default:
                    if (x[p] !== y[p]) {
                        return false;
                    }
                    break;
            }
        }
        return true;
    }

    if (arguments.length < 1) {
        return true; //Die silently? Don't know how to handle such case, please help...
        // throw "Need two or more arguments to compare";
    }
    for (i = 1, l = arguments.length; i < l; i++) {
        leftChain = []; //Todo: this can be cached
        rightChain = [];
        if (!compare2Objects(arguments[0], arguments[i])) {
            return false;
        }
    }
    return true;
}
/**
 * 起运地目的地统一处理
 */
export function handleChangeArea(_this, city, cityValue, country, area, areaValue) {
    if (!( Array.isArray(areaValue) && areaValue.length > 0)) {
        areaValue = [..._this.state[area]]
    }
    const a = areaValue.filter(o => cityValue == o.cityName);
    const data = {
        [country]: (a.length > 0) ? a[0].countryName : '',
        [city]: cityValue,
    };
    if (areaValue) {
        data[area] = areaValue;
    }
    _this.props.form.setFieldsValue({[city]: cityValue,});
    _this.setState(data);
    return a;
};
/**
 * 租还箱统一处理
 */
export function handleChangeRentalBox(_this, station, stationValue, box, boxValue) {
    if (!( Array.isArray(boxValue) && boxValue.length > 0)) {
        boxValue = [..._this.state[box]]
    }
    const data = {
        //[station]: stationValue == null ? boxValue[0].content : stationValue,
        [station]: stationValue,
    };
    if (boxValue) {
        data[box] = boxValue;
    }
    _this.setState(data);
};
/**
 * 货物类型选择
 * @param e
 */
export function handleChangePackageType(_this, value, checked) {
    if (value === 'packageTypeSmall') {
        _this.setState({packageType1: false, packageType2: checked, packageType3: checked, packageType4: checked})
    }
    if ((value === 'packageTypeNormal' || value === 'packageTypeSale') && checked) {
        _this.setState({packageType1: true, packageType2: false, packageType3: true, packageType4: true})
    }
    if ((value === 'packageTypeNormal' && !checked && _this.state.packageTypeSale === 'N') ||
        (value === 'packageTypeSale' && !checked && _this.state.packageTypeNormal === 'N')) {
        _this.setState({packageType1: false, packageType2: false, packageType3: false, packageType4: false})
    }
    if (value === 'packageTypeDeclare') {
        _this.setState({packageType1: checked, packageType2: checked, packageType3: false, packageType4: checked})
    }
    if (value === 'packageTypeTransfer') {
        _this.setState({packageType1: checked, packageType2: checked, packageType3: checked, packageType4: false})
    }
    _this.setState({[value]: checked ? 'Y' : 'N'})
};
/**
 * rangeDatePicker数据类型统一转换
 * @param values
 * @param names
 */

export function transferDateValus(values, names = []) {
    for (let key of  Object.keys(values)) {
        if (values[key] != null) {
            for (let name of names) {
                if (key === name) {
                    if (values[key].length > 0) {
                        let dateFrom = values[key][0].format('YYYY-MM-DD');
                        let dateTo = values[key][1].format('YYYY-MM-DD');
                        values[key + 'From'] = dateFrom + ' 00:00:00';
                        values[key + 'To'] = dateTo + ' 23:59:59';
                        delete values[key];
                    }
                } else {
                    continue;
                }
            }
        }
    }
}
//文件图标
export function getIcons(record = {}, deliveryType) {
    if (DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType)) {
        return <span>
            {record.boxFileVehicle === 'Y' ?
                <YgIcon type="icon-dan" style={{fontSize: fontSize, color: color1Y}}/> :
                <YgIcon type="icon-dan" style={{fontSize: fontSize, color: color}}/>}
            {record.boxFileNums > 0 ? ( record.boxFileNums > 1 ?
                <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color5Y}}/> :
                <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color2Y}}/>) :
                <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color}}/>}
            {record.boxFileReturn === 'Y' ?
                <YgIcon type="icon-xiang" style={{fontSize: fontSize, color: color3Y}}/> :
                <YgIcon type="icon-xiang" style={{fontSize: fontSize, color: color}}/>}
            {deliveryType === 'X' ? //新疆班列
                (record.dskNo === 'Y' ?
                    <YgIcon type="icon-MRN" style={{fontSize: fontSize, color: color5Y}}/> :
                    <YgIcon type="icon-MRN" style={{fontSize: fontSize, color: color}}/> ) :
                (record.dskNo === 'Y' ?
                    <YgIcon type="icon-DSK" style={{fontSize: fontSize, color: color5Y}}/> :
                    <YgIcon type="icon-DSK" style={{fontSize: fontSize, color: color}}/> )}
            {record.boxWeightNums > 1 ?
                <YgIcon type="icon-ATB" style={{fontSize: fontSize, color: color4YDeep}}/> :
                (record.boxWeightNums === 1 ?
                    <YgIcon type="icon-ATB" style={{fontSize: fontSize, color: color4Y}}/> :
                    <YgIcon type="icon-ATB" style={{fontSize: fontSize, color: color}}/> )}
                    </span>
    } else {
        if (record.subType == 'A') {//一箱到底
            return <span>
            {record.boxFileVehicle === 'Y' ?
                <YgIcon type="icon-dan" style={{fontSize: fontSize, color: color1Y}}/> :
                <YgIcon type="icon-dan" style={{fontSize: fontSize, color: color}}/>}
                {record.boxFileNums > 0 ? ( record.boxFileNums > 1 ?
                    <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color5Y}}/> :
                    <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color2Y}}/>) :
                    <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color}}/>}
                {record.boxFileReturn === 'Y' ?
                    <YgIcon type="icon-xiang" style={{fontSize: fontSize, color: color3Y}}/> :
                    <YgIcon type="icon-xiang" style={{fontSize: fontSize, color: color}}/>}
                {record.boxT1 === 'Y' ?
                    <YgIcon type="icon-T1" style={{fontSize: fontSize, color: color4Y}}/> :
                    <YgIcon type="icon-T1" style={{fontSize: fontSize, color: color}}/>}
            </span>
        } else {//倒装运输
            return <span>
            {record.boxFileVehicle === 'Y' ?
                <YgIcon type="icon-dan" style={{fontSize: fontSize, color: color1Y}}/> :
                <YgIcon type="icon-dan" style={{fontSize: fontSize, color: color}}/>}
                {record.boxFileNums > 0 ? ( record.boxFileNums > 1 ?
                    <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color5Y}}/> :
                    <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color2Y}}/>) :
                    <YgIcon type="icon-yun" style={{fontSize: fontSize, color: color}}/>}
                {record.boxT1 === 'Y' ?
                    <YgIcon type="icon-T1" style={{fontSize: fontSize, color: color4Y}}/> :
                    <YgIcon type="icon-T1" style={{fontSize: fontSize, color: color}}/>}
            </span>
        }
    }
}
//车牌号 挂号展示
export function getVehicleInfo(truckNo, hangNo) {
    if (truckNo && hangNo) {
        return truckNo + '/' + hangNo;
    }
    if (truckNo && !hangNo) {
        return truckNo;
    }
    if (!truckNo && hangNo) {
        return hangNo;
    }
    return ''
}